import cookies from 'js-cookie';
import { queryString } from '../utils/url-helper';
import { getPlatform } from '../tj-utils/platform';
/**
 * 初始化页面级别的 UTM/CODE
 * 需要放在页面加载前面就执行完成
 */
export function initUtmCode() {
    var refUrl = decodeURIComponent(queryString('refurl') || '') || document.referrer;
    var isTjSiteRefStr = queryString('istjsite');
    var clickId = queryString('click_id') || '';
    if (clickId && (clickId === null || clickId === void 0 ? void 0 : clickId.indexOf('tujia_xhs_')) < 0) {
        clickId = 'tujia_xhs_' + clickId;
    }
    var code = queryString('tujia_code') || queryString('code');
    var outcode = queryString('outcode') || clickId;
    var utm = queryString('utm_source');
    var channelId = queryString('tjchannelid');
    // 如果url中不存在istjsite这个参数且有refUrl 情况下 需要对isTjSiteRefStr进行冲设定
    if (!isTjSiteRefStr && refUrl) {
        var isTrue = /^http(s?):\/\/[a-zA-Z1-9]*([1-9]{0,4}.(fvt|beta|dev))?.tujia.com/.test(refUrl);
        isTjSiteRefStr = isTrue ? 'true' : 'false';
    }
    function setCookieByDays(key, value, days) {
        cookies.set(key, value, {
            domain: 'tujia.com',
            expires: days
        });
    }
    function initSemCode() {
        if (isTjSiteRefStr == 'false' ||
            (channelId && (channelId !== 'tujia' || getPlatform().isMpEnv))) {
            if (!channelId && refUrl && refUrl.indexOf('tujia.com') <= -1) {
                setCookieByDays('tujia_out_site_landingUrl', window.location.href, 1);
                setCookieByDays('tujia_out_site_referrerUrl', refUrl, 1);
            }
            else {
                setCookieByDays('tujia_out_site_landingUrl', '', -1);
                setCookieByDays('tujia_out_site_referrerUrl', '', -1);
            }
            if (code) {
                setCookieByDays('tujia_code', code, 7);
            }
            else if (!channelId || channelId === 'tujia') {
                setCookieByDays('tujia_code', '', 0);
            }
            if (utm) {
                setCookieByDays('tujia_utm', utm, 7);
            }
            else {
                setCookieByDays('tujia_utm', '', 0);
            }
        }
        else {
            if (code) {
                setCookieByDays('tujia_code_site', code, 0.1);
            }
        }
        if (outcode) {
            setCookieByDays('outcode', outcode, 7);
        }
        else if (!channelId || channelId === 'tujia') {
            setCookieByDays('outcode', '', 0);
        }
    }
    initSemCode();
    var semCodeInfo = getSemCodeInfo();
    // TODO: 后续应该做下线处理，换成 getSemCodeInfo 逻辑
    window.tjGlobal = window.tjGlobal || {};
    window.tjGlobal.tujia_code = semCodeInfo.code;
    window.tjGlobal.outcode = semCodeInfo.outcode;
    window.tjGlobal.tujia_utm = semCodeInfo.utm;
    window.tjGlobal.tujia_code_site = semCodeInfo.siteCode;
    window.tjGlobal.tujia_out_site_landingUrl = semCodeInfo.landingUrl;
    window.tjGlobal.tujia_out_site_referrerUrl = semCodeInfo.referrerUrl;
}
/**
 * 获取当前 semCode 信息
 */
export function getSemCodeInfo() {
    var cookie = cookies.get();
    return {
        code: cookie.tujia_code,
        outcode: cookie.outcode,
        utm: cookie.tujia_utm,
        siteCode: cookie.tujia_code_site,
        landingUrl: cookie.tujia_out_site_landingUrl,
        referrerUrl: cookie.tujia_out_site_referrerUrl
    };
}
